import React from "react";
import {
  FaCoins,
  FaDatabase,
  FaFileContract,
  FaImage,
  FaProjectDiagram,
  FaWallet,
} from "react-icons/fa";

function Web3Features() {
  const features = [
    {
      title: "Decentralized Application (dApp) Development",
      desc: "Unlock the potential of decentralized applications with Xeer Technology’s dApp development services. We design and develop dApps that offer seamless user experiences, improved security, and full transparency for users and businesses alike.",
      icon: <FaProjectDiagram />,
    },
    {
      title: "Blockchain Network Development",
      desc: "From private to public blockchain solutions, Xeer Technology offers full-stack blockchain network development. We build custom blockchain protocols tailored to your business needs, utilizing advanced consensus mechanisms and ensuring interoperability with existing systems.",
      icon: <FaDatabase />,
    },
    {
      title: "Smart Contract Development & Audits",
      desc: "Our team specializes in building secure, efficient, and cost-effective smart contracts to automate business processes and financial transactions on the blockchain. We also conduct comprehensive audits to identify and mitigate potential risks.",
      icon: <FaFileContract />,
    },
    {
      title: "NFT Development Services",
      desc: "As NFTs continue to revolutionize asset ownership, Xeer Technology offers end-to-end NFT development services. From creating unique digital assets to developing platforms for NFT trading, we make your vision a reality.",
      icon: <FaImage />,
    },
    {
      title: "DeFi Solutions",
      desc: "With deep expertise in decentralized finance, Xeer Technology provides development services for DeFi platforms, including lending, borrowing, staking, and liquidity solutions. We help your business tap into the transformative power of DeFi.",
      icon: <FaCoins />,
    },
    {
      title: "Web3 Wallet Development",
      desc: "Our Web3 wallet development services focus on creating user-friendly, secure wallets that support a wide array of assets and blockchain networks. These wallets are ideal for businesses looking to enhance accessibility for their users in a decentralized environment.",
      icon: <FaWallet />,
    },
  ];

  return (
    <div
      className="features-area pt-120 pb-120"
      style={{ background: "#ffffff" }}
    >
      <div className="container">
        <div className="section-title text-center mb-5">
          <h2 className="title fw-900">
            Our Top-notch Web3 Development Services
          </h2>
          <p
            className="mt-3 text-muted mx-auto"
            style={{ maxWidth: "700px", fontSize: "18px" }}
          >
            We provide the technical expertise to navigate the transition from
            centralized platforms to a transparent Web3 world.
          </p>
        </div>

        <div className="row g-4 mt-4">
          {features.map((feature, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div
                className="feature-card p-5 h-100"
                style={{
                  borderRadius: "32px",
                  background: "#f0f7ff",
                  border: "1px solid #e0efff",
                  transition: "all 0.4s ease",
                  cursor: "default",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "translateY(-10px)";
                  e.currentTarget.style.background = "#ffffff";
                  e.currentTarget.style.boxShadow =
                    "0 25px 50px rgba(33, 150, 243, 0.05)";
                  e.currentTarget.style.borderColor = "#2196f320";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.background = "#f0f7ff";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "#e0efff";
                }}
              >
                <div className="icon-box mb-4 d-flex align-items-center justify-content-center">
                  <div>{feature.icon}</div>
                </div>
                <h4
                  className="fw-bold mb-3"
                  style={{ fontSize: "20px", color: "#0e1217" }}
                >
                  {feature.title}
                </h4>
                <p
                  className="text-muted mb-0"
                  style={{ fontSize: "15px", lineHeight: "1.7" }}
                >
                  {feature.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Web3Features;
